module.exports = __webpack_public_path__ + "static/img/image-002.ca99cd71.jpeg";